import {IService, Context} from 'egg';

export abstract class AContainerStoreBase {
  public root: any;

  public  async ssrInit(ctx: Context, ...otherParams) {
    // must be implemented in derived classes
  }

  public toJson(): any {
    // must be implemented in derived classes
    return {};
  }
}
